import { LoginRequest, LoginResponse } from '@oy/types';
import axios, { AUTH_PREFIX_V2 } from 'src/clients/axios';

export const authLogin = (data: LoginRequest) => {
  return axios.post<LoginResponse>(`${AUTH_PREFIX_V2}/auth/login`, data, {
    disableToast: true,
  });
};
